import type { ReactNode } from 'react';

interface ErrorPanelProps {
  title?: string;
  message: ReactNode;
  onRetry: () => void;
  retryLabel?: string;
  secondaryLabel?: string;
  onSecondary?: () => void;
}

export function ErrorPanel({
  title = 'Access Denied',
  message,
  onRetry,
  retryLabel = 'Try again',
  secondaryLabel,
  onSecondary,
}: ErrorPanelProps) {
  return (
    <div className="flex flex-col items-center gap-6 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-500/20">
        <svg className="h-8 w-8 text-red-500 dark:text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
          />
        </svg>
      </div>

      <div>
        <h2 className="font-khand-semibold text-xl text-gray-800 dark:text-white">{title}</h2>
        <p className="mt-2 text-left text-sm break-words text-gray-500 dark:text-gray-400">{message}</p>
      </div>

      <div className="flex gap-3">
        <button
          onClick={onRetry}
          className="rounded-lg border border-sf-blue-vibrant px-6 py-2 text-sm font-medium text-sf-blue-vibrant transition-colors hover:bg-sf-blue-vibrant/10"
        >
          {retryLabel}
        </button>
        {secondaryLabel && onSecondary && (
          <button
            onClick={onSecondary}
            className="rounded-lg border border-gray-300 px-6 py-2 text-sm font-medium text-gray-500 transition-colors hover:bg-gray-100 dark:border-white/20 dark:text-gray-400 dark:hover:bg-white/10"
          >
            {secondaryLabel}
          </button>
        )}
      </div>
    </div>
  );
}
